import { render } from "./old-world-craftsmanship.vue?vue&type=template&id=7d23a08f&scoped=true"
import script from "./old-world-craftsmanship.vue?vue&type=script&lang=js"
export * from "./old-world-craftsmanship.vue?vue&type=script&lang=js"

import "./old-world-craftsmanship.vue?vue&type=style&index=0&id=7d23a08f&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d23a08f"]])

export default __exports__